/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { KEngineResponseContainerProviderResponseOfMasteredLocations } from '../models/k-engine-response-container-provider-response-of-mastered-locations';
import { KEngineResponseContainerProviderResponseOfPractitionerRoles } from '../models/k-engine-response-container-provider-response-of-practitioner-roles';
import { NaturalLanguageProviderSearchRequest } from '../models/natural-language-provider-search-request';
import { NaturalLanguageSearchResponseV3 } from '../models/natural-language-search-response-v-3';
import { ProviderSearchRequest } from '../models/provider-search-request';

@Injectable({
  providedIn: 'root',
})
export class ProviderSearchService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation naturalLanguageProviderSearchCareFindr
   */
  static readonly NaturalLanguageProviderSearchCareFindrPath = '/v3/provider/nl-search-carefindr';

  /**
   * Provider search using natural language query.
   *
   * Accepts a natural language query and converts it to a structured provider search request.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `naturalLanguageProviderSearchCareFindr()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  naturalLanguageProviderSearchCareFindr$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Natural language provider search request. Example: { "query": "cardiologists near 90210" }
     */
    body: NaturalLanguageProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ProviderSearchRequest>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.NaturalLanguageProviderSearchCareFindrPath, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProviderSearchRequest>;
      })
    );
  }

  /**
   * Provider search using natural language query.
   *
   * Accepts a natural language query and converts it to a structured provider search request.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `naturalLanguageProviderSearchCareFindr$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  naturalLanguageProviderSearchCareFindr(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Natural language provider search request. Example: { "query": "cardiologists near 90210" }
     */
    body: NaturalLanguageProviderSearchRequest
  },
  context?: HttpContext

): Observable<ProviderSearchRequest> {

    return this.naturalLanguageProviderSearchCareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<ProviderSearchRequest>) => r.body as ProviderSearchRequest)
    );
  }

  /**
   * Path part for operation naturalLanguageProviderSearchCareFindrV3
   */
  static readonly NaturalLanguageProviderSearchCareFindrV3Path = '/provider/nl-search';

  /**
   * Provider search using natural language query: Use this endpoint for CareFindr V3 frontend.
   *
   * Accepts a natural language query and converts it to a structured provider search request for CareFindr V3 frontend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `naturalLanguageProviderSearchCareFindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  naturalLanguageProviderSearchCareFindrV3$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Natural language provider search request. Example: { "query": "cardiologists near 90210" }
     */
    body: NaturalLanguageProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<NaturalLanguageSearchResponseV3>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.NaturalLanguageProviderSearchCareFindrV3Path, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<NaturalLanguageSearchResponseV3>;
      })
    );
  }

  /**
   * Provider search using natural language query: Use this endpoint for CareFindr V3 frontend.
   *
   * Accepts a natural language query and converts it to a structured provider search request for CareFindr V3 frontend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `naturalLanguageProviderSearchCareFindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  naturalLanguageProviderSearchCareFindrV3(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Natural language provider search request. Example: { "query": "cardiologists near 90210" }
     */
    body: NaturalLanguageProviderSearchRequest
  },
  context?: HttpContext

): Observable<NaturalLanguageSearchResponseV3> {

    return this.naturalLanguageProviderSearchCareFindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<NaturalLanguageSearchResponseV3>) => r.body as NaturalLanguageSearchResponseV3)
    );
  }

  /**
   * Path part for operation multiTenantProviderSearchV2CareFindr
   */
  static readonly MultiTenantProviderSearchV2CareFindrPath = '/v3/provider/search-carefindr';

  /**
   * Multi-tenant provider search.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderSearchV2CareFindr()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderSearchV2CareFindr$Response(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Provider Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.MultiTenantProviderSearchV2CareFindrPath, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>;
      })
    );
  }

  /**
   * Multi-tenant provider search.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderSearchV2CareFindr$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderSearchV2CareFindr(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Provider Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfPractitionerRoles> {

    return this.multiTenantProviderSearchV2CareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>) => r.body as KEngineResponseContainerProviderResponseOfPractitionerRoles)
    );
  }

  /**
   * Path part for operation multiTenantProviderDetailCareFindr
   */
  static readonly MultiTenantProviderDetailCareFindrPath = '/v3/carefindr/practitioner-role/{uid}';

  /**
   * Multi-tenant provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderDetailCareFindr()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderDetailCareFindr$Response(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * Latitude for distance-based sorting of provider locations
     */
    lat?: string;

    /**
     * Longitude for distance-based sorting of provider locations
     */
    lng?: string;

    /**
     * Location Stable ID of the Provider Search query display location. Used to keep the locations results consistent
     */
    'location-stable-id-hash'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.MultiTenantProviderDetailCareFindrPath, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.query('lat', params.lat, {});
      rb.query('lng', params.lng, {});
      rb.query('location-stable-id-hash', params['location-stable-id-hash'], {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>;
      })
    );
  }

  /**
   * Multi-tenant provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderDetailCareFindr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderDetailCareFindr(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * Latitude for distance-based sorting of provider locations
     */
    lat?: string;

    /**
     * Longitude for distance-based sorting of provider locations
     */
    lng?: string;

    /**
     * Location Stable ID of the Provider Search query display location. Used to keep the locations results consistent
     */
    'location-stable-id-hash'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfMasteredLocations> {

    return this.multiTenantProviderDetailCareFindr$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>) => r.body as KEngineResponseContainerProviderResponseOfMasteredLocations)
    );
  }

  /**
   * Path part for operation multiTenantProviderSearch
   */
  static readonly MultiTenantProviderSearchPath = '/v2/practitioner-role/search';

  /**
   * Multi-tenant provider search.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderSearch()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderSearch$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Single Stroke ES search ported over from dotnet6
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.MultiTenantProviderSearchPath, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>;
      })
    );
  }

  /**
   * Multi-tenant provider search.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderSearch$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  multiTenantProviderSearch(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Single Stroke ES search ported over from dotnet6
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfPractitionerRoles> {

    return this.multiTenantProviderSearch$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>) => r.body as KEngineResponseContainerProviderResponseOfPractitionerRoles)
    );
  }

  /**
   * Path part for operation multiTenantProviderDetail
   */
  static readonly MultiTenantProviderDetailPath = '/v2/practitioner-role/{uid}';

  /**
   * Multi-tenant provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `multiTenantProviderDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderDetail$Response(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.MultiTenantProviderDetailPath, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>;
      })
    );
  }

  /**
   * Multi-tenant provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call. This endpoint is for CareFindr usage only.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `multiTenantProviderDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  multiTenantProviderDetail(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent. <br/> No cap on the number of hits to APIs
     */
    'x-user-id'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfMasteredLocations> {

    return this.multiTenantProviderDetail$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>) => r.body as KEngineResponseContainerProviderResponseOfMasteredLocations)
    );
  }

  /**
   * Path part for operation providerSearchCarefindrV3
   */
  static readonly ProviderSearchCarefindrV3Path = '/provider/search';

  /**
   * Carefindr Provider search. These routes are to be used for Carefindr V3.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `providerSearchCarefindrV3()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerSearchCarefindrV3$Response(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Provider Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.ProviderSearchCarefindrV3Path, 'post');
    if (params) {
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json; charset=utf-8');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>;
      })
    );
  }

  /**
   * Carefindr Provider search. These routes are to be used for Carefindr V3.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `providerSearchCarefindrV3$Response()` instead.
   *
   * This method sends `application/json; charset=utf-8` and handles request body of type `application/json; charset=utf-8`.
   */
  providerSearchCarefindrV3(params: {

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Two Stroke Provider Request. See design: https://leaporbit.atlassian.net/wiki/spaces/CONVERGENT/pages/53739533/Two-stroke+Design
     */
    body: ProviderSearchRequest
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfPractitionerRoles> {

    return this.providerSearchCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfPractitionerRoles>) => r.body as KEngineResponseContainerProviderResponseOfPractitionerRoles)
    );
  }

  /**
   * Path part for operation providerDetailCarefindrV3
   */
  static readonly ProviderDetailCarefindrV3Path = '/provider/search/{uid}';

  /**
   * Provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `providerDetailCarefindrV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  providerDetailCarefindrV3$Response(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent.
     */
    'x-user-id'?: string;

    /**
     * Latitude for distance-based sorting of provider locations
     */
    lat?: string;

    /**
     * Longitude for distance-based sorting of provider locations
     */
    lng?: string;

    /**
     * Location Stable ID of the Provider Search query display location. Used to keep the locations results consistent
     */
    'location-stable-id-hash'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>> {

    const rb = new RequestBuilder(this.rootUrl, ProviderSearchService.ProviderDetailCarefindrV3Path, 'get');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.header('x-user-id', params['x-user-id'], {});
      rb.query('lat', params.lat, {});
      rb.query('lng', params.lng, {});
      rb.query('location-stable-id-hash', params['location-stable-id-hash'], {});
      rb.header('Accept-Language', params['Accept-Language'], {});
      rb.query('explain', params.explain, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>;
      })
    );
  }

  /**
   * Provider detail.
   *
   * This interface is invoked when the user clicks on the name of the provider on the provider results page, in order to fetch additional information<br/>such as certification, education, all the languages spoken, Board Certification by making a HTTPS GET Call.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `providerDetailCarefindrV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  providerDetailCarefindrV3(params: {

    /**
     * Unique ID assigned to the provider.
     */
    uid: string;

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * Unique id per user that is requesting data from convergent.
     */
    'x-user-id'?: string;

    /**
     * Latitude for distance-based sorting of provider locations
     */
    lat?: string;

    /**
     * Longitude for distance-based sorting of provider locations
     */
    lng?: string;

    /**
     * Location Stable ID of the Provider Search query display location. Used to keep the locations results consistent
     */
    'location-stable-id-hash'?: string;

    /**
     * Specifies the language for translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;

    /**
     * (Internal usage) Set to true to turn on debugging.
     */
    explain?: boolean;
  },
  context?: HttpContext

): Observable<KEngineResponseContainerProviderResponseOfMasteredLocations> {

    return this.providerDetailCarefindrV3$Response(params,context).pipe(
      map((r: StrictHttpResponse<KEngineResponseContainerProviderResponseOfMasteredLocations>) => r.body as KEngineResponseContainerProviderResponseOfMasteredLocations)
    );
  }

}
